//router.js
import React from 'react';
import {BrowserRouter as Router, Route, Redirect, Switch} from "react-router-dom";

import Login from '../portal/Login';
import Frame from '../frame/Frame';
import Home from '../frame/Home';

import HomePage from '../pages/HomePage';
import BusinessChance from "../pages/BusinessChance"
import NearbyEnt from "../pages/NearbyEnt"
import Vertical from "../pages/vertical"
import EnterpriseMonitoringList from "../pages/EnterpriseMonitoringList"
import SearchTag from '../pages/SearchTag';
import EntityDetail from '../pages/EntityDetail';
import EnterpriseSearch from '../pages/EnterpriseSearch';
import CRM from '../pages/CRM';
import MultipointAssociation from "../pages/MultipointAssociation"
import SinglePointAssociation from "../pages/SinglePointAssociation"
import Marketing from "../pages/marketing"

import System from '../pages/system/System';
import User from '../pages/system/User';
import UserCreate from '../pages/system/UserCreate';
import Role from '../pages/system/Role';
import roleUser from '../pages/system/roleUser';
import RolePrivilege from '../pages/system/RolePrivilege';
import Department from '../pages/system/Department';
import DepartmentPrivilege from '../pages/system/DepartmentPrivilege';
import UserLog from '../pages/system/UserLog';
import Uims from '../pages/system/Uims';
import Method from "../pages/system/Method"
import Component from "../pages/system/Component"
import DepartmentUser from '../pages/system/DepartmentUser';
import Group from '../pages/system/Group';
import userDomain from '../pages/system/userDomain'


class FrameRouter extends React.Component{
    render(){
        
        return(
            <Router basename="/SCRM">
                <Route exact path="/" component={Login}></Route>
				<Route path="/Login" component={Login}></Route>                  
                <Route path="/home" render={ ({match}) => {

                    let access = sessionStorage.getItem("_user_access_");

                    if( access )
                    {
                        let pathBase = match.path;

                        return(
                            <Router basename="/SCRM">
                                <Switch>
                                    <FrameRoute exact path={ pathBase + "/" } component={Home} model="home"/>
                                    <FrameRoute  path={ pathBase + "/homePage" } component={HomePage}/>
                                    <FrameRoute  path={ pathBase + "/businessChance" } component={BusinessChance}/>
                                    <FrameRoute  path={ pathBase + "/nearbyent" } component={NearbyEnt}/>
                                    <FrameRoute  path={ pathBase + "/enterpriseMonitoring" } component={EnterpriseMonitoringList}/>
                                    <FrameRoute  path={ pathBase + "/Vertical" } component={Vertical}/>
                                    <FrameRoute  path={ pathBase + "/searchTag" } component={SearchTag}/>
                                    <FrameRoute  path={ pathBase + "/entityDetail" } component={EntityDetail}/>
                                    <FrameRoute  path={ pathBase + "/enterpriseSearch" } component={EnterpriseSearch}/>
                                    <FrameRoute  path={ pathBase + "/CRM" } component={CRM}/>
                                    <FrameRoute  path={ pathBase + "/multipointassociation" } component={MultipointAssociation}/>
                                    <FrameRoute  path={ pathBase + "/singlepointassociation" } component={SinglePointAssociation}/>
                                    <FrameRoute  path={ pathBase + "/marketing" } component={Marketing}/>
                                    
                                    <FrameRoute  path={ pathBase + "/system" } component={System}/>
                                    <FrameRoute  path={ pathBase + "/user" } component={User}/>
                                    <FrameRoute  path={ pathBase + "/userCreate" } component={UserCreate}/>
                                    <FrameRoute  path={ pathBase + "/Method" } component={Method}/>
                                    <FrameRoute  path={ pathBase + "/Component" } component={Component}/>
                                    <FrameRoute  path={ pathBase + "/Uims" } component={Uims}/>

                                    <FrameRoute  path={ pathBase + "/role" } component={Role}/>
                                    <FrameRoute  path={ pathBase + "/roleUser" } component={roleUser}/>
                                    <FrameRoute  path={ pathBase + "/group" } component={Group}/>
                                    <FrameRoute  path={ pathBase + "/userDomain" } component={userDomain}/>
                                    <FrameRoute  path={ pathBase + "/rolePrivilege" } component={RolePrivilege}/>
                                    <FrameRoute  path={ pathBase + "/department" } component={Department}/>
                                    <FrameRoute  path={ pathBase + "/departmentPrivilege" } component={DepartmentPrivilege}/>
                                    <FrameRoute  path={ pathBase + "/userLog" } component={UserLog}/>
                                    <FrameRoute  path={ pathBase + "/departmentuser" } component={DepartmentUser}/>
                                </Switch> 
                            </Router>
                        )
                    }
                    else
                    {
                        return (
                            <Redirect to="/Login"/>
                        )
                    }
                }} ></Route>    
            </Router>   
        )
    }
}

const FrameRoute = ({component: Component, model, ...rest}) => (
    <Route {...rest} render={(props) => (
        <Frame model={model} >
            <Component {...props} />
        </Frame>
    ) } />
)

export default FrameRouter


